export default "__VITE_ASSET__BVycqCI4__"